.card {
  transition: opacity 300ms;
  border-radius: var(--radiusMd); // it should match Card radius

  &.entering,
  &.exiting {
    opacity: 0;
  }

  &.entered,
  &.exited {
    transition-delay: 200ms; // time for expanding/shrinking the card
    opacity: 1;
  }
}

.selectedCard {
  box-shadow: inset 0 0 0 2px var(--palettePrimary0);
}
